export default __webpack_public_path__ + "static/media/copy.77455348.svg";